import type { ElementDefinition } from './types';
import type { TemplateProfile } from '../templates';
import { insertExhibit } from '../word/exhibit';

/** Element definition for half-with-text exhibit insertion. */
export const halfWithTextExhibitElement: ElementDefinition = {
  id: 'half-with-text-exhibit',
  label: 'Graph + Text',
  icon: 'TableCellsSplitRegular',
  description: 'Half-width graph with text column',
  category: 'exhibit',
  async insertAsync(profile: TemplateProfile): Promise<void> {
    await insertExhibit('half-with-text', profile);
  },
};

/** Toolbar action for half-with-text exhibit insertion. */
export async function insertGraphHalfWithTextLayout(profile: TemplateProfile): Promise<void> {
  await insertExhibit('half-with-text', profile);
}
